// =============================================================================
// wizard.ts -- Patch 011.A frontend API client for the setup wizard state.
// =============================================================================

import { request } from './request'
import type { PatchWizardInput, WizardState } from './types'

export const wizardApi = {
  get: (projectId: string) =>
    request<{ ok: true; wizard: WizardState; request_id?: string }>(
      `/api/projects/${encodeURIComponent(projectId)}/wizard`,
    ),

  patch: (projectId: string, body: PatchWizardInput) =>
    request<{
      ok: true
      id: string
      project_id: string
      updated: string[]
      request_id: string
    }>(`/api/projects/${encodeURIComponent(projectId)}/wizard`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    }),
}
